import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

export function Comment(props: { isZigzagApp?: boolean; label: string; text: string; percent: number }) {
  return (
    <Container className={Typography.CAPTION_12_SEMIBOLD}>
      <Label className={props.isZigzagApp ? Typography.CAPTION_12_MEDIUM : ''}>{props.label}:</Label>
      <Text className={props.isZigzagApp ? Typography.CAPTION_12_MEDIUM : ''} isZigzagApp={props.isZigzagApp}>
        {props.text}
      </Text>
      <Percent>{`(${props.percent}%)`}</Percent>
    </Container>
  );
}

const Container = styled.div`
  padding: 0 16px;
  line-height: 18px;
`;

const Label = styled.span`
  color: ${vars.color.textTertiary};
  margin-right: 4px;
`;

const Text = styled.span<{ isZigzagApp?: boolean }>`
  color: ${vars.color.textTertiary};
  ${({ isZigzagApp }) => !isZigzagApp && 'margin-right: 4px'};
`;

const Percent = styled.span`
  color: ${vars.color.textTertiary};
`;
